export default function (data) {
  return data.map(item => {
    item.id = item.guid
    return item
  })
}
